import { action } from 'typesafe-actions';
import {
  DashboardStatsRequestPayload,
  DashboardEnquirerStatsResponse,
  DashboardAssetOwnerStatsResponse,
  DashboardActionTypes
} from 'types';

export const getDashboardEnquirerStatsStart = (
  payload: DashboardStatsRequestPayload
) => action(DashboardActionTypes.GET_DASHBOARD_ENQUIRER_STATS_START, payload);

export const getDashboardEnquirerStatsSuccess = (
  payload: DashboardEnquirerStatsResponse
) => action(DashboardActionTypes.GET_DASHBOARD_ENQUIRER_STATS_SUCCESS, payload);

export const getDashboardEnquirerStatsFailure = (payload: string) =>
  action(DashboardActionTypes.GET_DASHBOARD_ENQUIRER_STATS_FAILURE, payload);

export const getDashboardAssetOwnerStatsStart = (
  payload: DashboardStatsRequestPayload
) => action(DashboardActionTypes.GET_DASHBOARD_ASSETONWER_STATS_START, payload);

export const getDashboardAssetOwnerStatsSuccess = (
  payload: DashboardAssetOwnerStatsResponse
) =>
  action(DashboardActionTypes.GET_DASHBOARD_ASSETONWER_STATS_SUCCESS, payload);

export const getDashboardAssetOwnerStatsFailure = (payload: string) =>
  action(DashboardActionTypes.GET_DASHBOARD_ASSETONWER_STATS_FAILURE, payload);

export const getDashboardDBYDStatsStart = (
  payload: DashboardStatsRequestPayload
) => action(DashboardActionTypes.GET_DASHBOARD_DBYD_STATS_START, payload);

export const getDashboardDBYDStatsSuccess = (
  payload: DashboardAssetOwnerStatsResponse
) => action(DashboardActionTypes.GET_DASHBOARD_DBYD_STATS_SUCCESS, payload);

export const getDashboardDBYDStatsFailure = (payload: string) =>
  action(DashboardActionTypes.GET_DASHBOARD_DBYD_STATS_FAILURE, payload);

export const resetDashboadrdState = () =>
  action(DashboardActionTypes.RESET_DASHBOARD_STATE);

export const setDashboardUIStateRangeText = (payload: string) =>
  action(DashboardActionTypes.SET_DASHBOARD_UI_STATE_RANGE_TEXT, payload);

export const setDashboardUIStateShowGrid = (payload: boolean) =>
  action(DashboardActionTypes.SET_DASHBOARD_UI_STATE_SHOW_GRID, payload);

export const setDashboardUIStateShowShape = (payload: boolean) =>
  action(DashboardActionTypes.SET_DASHBOARD_UI_STATE_SHOW_SHAPE, payload);

export const setDashboardUIStateShowPoint = (payload: boolean) =>
  action(DashboardActionTypes.SET_DASHBOARD_UI_STATE_SHOW_POINT, payload);

export const setDashboardUIStateAdminRangeText = (payload: string) =>
  action(DashboardActionTypes.SET_DASHBOARD_UI_STATE_ADMIN_RANGE_TEXT, payload);
